import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

import history from '../../utils/history';
import { millisToHoursAndMinutesText } from '../../utils/numberFormatter';

class PracticeExamPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.isOpen,
      step1: true,
      step2: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  handleClick = () => {
    this.toggle();
    history.push('/app/study');
  };

  goToStep2 = () => {
    this.setState({ step1: false, step2: true });
  };

  launchExam = () => {
    this.toggle();
    this.props.launchExam();
  };

  handleOnClose = () => {
    this.toggle();
    history.push('/app/exams');
  };

  renderTextStep1 = () => (
    <p>
      This practice exam is timed and mimics what you'll see on exam day. A new
      practice exam is released every week and the four most recent ones stay
      available, so make sure you take it when you feel ready. And just like the
      real deal, there's no leaving and coming back to this exam – make sure you
      have the time to dedicate to the{' '}
      {millisToHoursAndMinutesText(this.props.exam?.examTimeInMillis)} time
      limit, and we highly recommend connecting to a charger if you're using a
      laptop. Good luck!
    </p>
  );

  renderCustomTextStep1 = () => (
    <p>
      This custom practice exam is timed. You can take up to one custom exam per
      day. And just like the real deal, there’s no leaving and coming back to
      this exam – make sure you have the time to dedicate to the{' '}
      {millisToHoursAndMinutesText(this.props.exam?.examTimeInMillis)} time
      limit, and we highly recommend connecting to a charger if you’re using a
      laptop. Good luck!
    </p>
  );

  renderTextStep2 = () => (
    <p>
      Once you launch the exam, the countdown timer will not stop and it cannot
      be reset. Please ensure you have{' '}
      {millisToHoursAndMinutesText(this.props.exam?.examTimeInMillis)} blocked
      out to make this exam. A new practice exam is released every week.
    </p>
  );

  renderCustomTextStep2 = () => (
    <p>
      Once you launch the exam, the countdown timer will not stop and it cannot
      be reset. Please ensure you have{' '}
      {millisToHoursAndMinutesText(this.props.exam?.examTimeInMillis)} blocked
      out to make this exam.
    </p>
  );

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.modal}
          className="practice-exam-popup modal-dialog-centered"
          toggle={this.handleOnClose}
        >
          <ModalHeader className="dark">
            <i className="icon-close" onClick={this.handleOnClose} />
            <span
              className="practice-exam-modal__title"
              data-test="welcome-title-test"
            >
              Welcome to Your Practice Exam
            </span>
            <p>
              Let's see how all of that studying is paying off with a full{' '}
              <span>{this.props.exam?.amountQuestions} </span>
              question practice exam.
            </p>
          </ModalHeader>
          <ModalBody>
            <div className={this.state.step1 ? 'show' : 'hide'}>
              {this.props.isCustom
                ? this.renderCustomTextStep1()
                : this.renderTextStep1()}
              <Button color="primary" size="xs" block onClick={this.goToStep2}>
                NEXT
              </Button>
            </div>
            <div className={this.state.step2 ? 'show' : 'hide'}>
              <b className="danger">WARNING</b>
              {this.props.isCustom
                ? this.renderCustomTextStep2()
                : this.renderTextStep2()}
              <Button
                color="primary"
                size="xs"
                block
                onClick={this.launchExam}
                data-test="launch-exam-button"
              >
                I UNDERSTAND, LAUNCH EXAM
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default PracticeExamPopUp;
